import {AnankeSpinner} from "@vesta/ananke/components/anankeSpinner";
import {AnankeSkeleton} from "@vesta/ananke/components/anankeSkeleton";
import {twJoin} from "tailwind-merge";

export function PendingComponent() {

    return (
        <div className="w-full h-full">
            <div className="w-full h-[48px] border-[1px] border-ds-border bg-ds-elevation-surface-current" />
            <div className="w-full h-full grid grid-cols-[clamp(240px,240px,50vw)_1fr] gap-0">
                <div className="w-[clamp(240px,240px,50vw)] h-[calc(100svh-48px)] border-r border-ds-border bg-ds-elevation-surface-current" />
                <div
                    className={twJoin(
                        "w-full h-full",
                        "relative",
                        //
                    )}
                >
                    {/* <div className="absolute inset-0 z-10 grid grid-cols-1 grid-rows-1 place-items-center content-center">Loading</div> */}
                    <div className="absolute inset-0 z-10 grid grid-cols-1 grid-rows-1 place-items-center content-center">
                        <AnankeSpinner
                            label=""
                        />
                    </div>
                    <AnankeSkeleton
                        width="100%"
                        height="100%"
                    />
                </div>

            </div>
        </div>
    );
}
